import React from 'react';
import styled from 'styled-components';

const PlaceholderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 1.2rem;
  border-radius: inherit;
  text-align: center;
  padding: 20px;
`;

const Placeholder = ({ text = "Placeholder Content" }) => {
  return (
    <PlaceholderContainer>
      {text}
    </PlaceholderContainer>
  );
};

export default Placeholder;